/**
 * Snapshot de fallback Phase 3.
 * GET /digital-loan/status es la fuente primaria.
 * El snapshot solo cubre campos que Backend aún no envía:
 * imagen de garantía y cancelación local.
 * TODO: remove snapshot fallback for guarantee image once Backend
 * adds guaranteeImageUrl or photo URL.
 * TODO: replace local cancel state with cancel-visit endpoint once
 * Backend provides the contract.
 */

import { PHASE3_SNAPSHOT_STORAGE_KEY } from 'constants/digitalLoanPhase3';

function emptyStore() {
  return { activeId: null, byId: {} };
}

function readStore() {
  try {
    const raw = window.sessionStorage.getItem(PHASE3_SNAPSHOT_STORAGE_KEY);
    if (!raw) return emptyStore();
    const parsed = JSON.parse(raw);
    return {
      activeId: parsed.activeId || null,
      byId: parsed.byId && typeof parsed.byId === 'object'
        ? parsed.byId
        : {},
    };
  } catch (error) {
    return emptyStore();
  }
}

function writeStore(store) {
  try {
    window.sessionStorage.setItem(
      PHASE3_SNAPSHOT_STORAGE_KEY,
      JSON.stringify(store),
    );
  } catch (error) {
    // Ignorar si sessionStorage no está disponible.
  }
}

export function getPhase3Snapshot(applicationId) {
  const store = readStore();
  const id = applicationId || store.activeId;
  if (!id) return null;
  return store.byId[id] || null;
}

export function savePhase3Snapshot(partial = {}) {
  const applicationId = partial.applicationId;
  if (!applicationId) return null;

  const store = readStore();
  const current = store.byId[applicationId] || {};
  const next = {
    ...current,
    ...partial,
    applicationId,
    updatedAt: new Date().toISOString(),
  };

  writeStore({
    activeId: applicationId,
    byId: {
      ...store.byId,
      [applicationId]: next,
    },
  });

  return next;
}

export function updatePhase3Snapshot(applicationId, patch = {}) {
  const current = getPhase3Snapshot(applicationId);
  if (!current && !applicationId) return null;
  return savePhase3Snapshot({
    ...(current || {}),
    applicationId: applicationId || current?.applicationId,
    ...patch,
  });
}

export function clearPhase3Snapshot(applicationId) {
  const store = readStore();
  if (!applicationId) {
    writeStore(emptyStore());
    return;
  }
  const nextById = { ...store.byId };
  delete nextById[applicationId];
  writeStore({
    activeId: store.activeId === applicationId ? null : store.activeId,
    byId: nextById,
  });
}
